import { render, staticRenderFns } from "./recept-install-orders.vue?vue&type=template&id=2c84f20b&scoped=true"
import script from "./recept-install-orders.vue?vue&type=script&lang=js"
export * from "./recept-install-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c84f20b",
  null
  
)

export default component.exports